import { DocumentNotificationEvent } from './documentNotificationTypes';

export type NotificationType =
  | 'case_note_flagged'
  | 'mr_rating_requested'
  | 'document_ready_for_signature'
  | 'document_signed'
  | 'parent_reminder'
  | 'general'
  | 'keystone_flag'
  | 'keystone_enrolment'
  | DocumentNotificationEvent;

export interface Notification {
  id: string;
  recipientId: string;
  type: NotificationType;
  title: string;
  message: string;
  linkUrl: string | null;
  referenceType: string | null;
  referenceId: string | null;
  isRead: boolean;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationRow {
  id: string;
  recipient_id: string;
  type: string;
  title: string;
  message: string;
  link_url: string | null;
  reference_type: string | null;
  reference_id: string | null;
  is_read: boolean;
  read_at: string | null;
  created_at: string;
}

export interface CreateNotificationData {
  recipientId: string;
  type: NotificationType;
  title: string;
  message: string;
  linkUrl?: string;
  referenceType?: string;
  referenceId?: string;
}

export interface NotificationEmailRow {
  id: string;
  notification_id: string;
  recipient_email: string;
  resend_id: string | null;
  status: 'pending' | 'sent' | 'delivered' | 'failed';
  sent_at: string | null;
  error_message: string | null;
  created_at: string;
}

export function transformNotificationRow(row: NotificationRow): Notification {
  return {
    id: row.id,
    recipientId: row.recipient_id,
    type: row.type as NotificationType,
    title: row.title,
    message: row.message,
    linkUrl: row.link_url,
    referenceType: row.reference_type,
    referenceId: row.reference_id,
    isRead: row.is_read,
    readAt: row.read_at,
    createdAt: row.created_at,
  };
}
